import React from 'react'
import { GlobalFont } from 'utils/GlobalFonts'
import Home from 'components/corpSite/components/careguide-corp/pages/home'

const CareGuideHomePage = (props) => {
  return (
    <>
      <GlobalFont />
      <Home />
    </>
  )
}
export default CareGuideHomePage
